import { dismissToast } from '../modules/toast'

// Every toast, flash or notification. A flash is rendered inside the page it came
// with and is moved into the stack here; a notification toast is appended to the
// stack directly. Either way it runs its countdown (see `blocks/toasts.sass`) and
// leaves when that ends, or when it is closed or followed.
up.compiler('.app-toast', (toast) => {
  const stack = document.getElementById('toasts')
  if (stack && !stack.contains(toast)) stack.appendChild(toast)

  const duration = parseInt(toast.dataset.toastDuration, 10) || 5000
  toast.style.setProperty('--app-toast-duration', `${duration}ms`)

  const countdown = toast.querySelector('.app-toast__countdown')

  // `animationend` bubbles, and the entrance animation of the toast itself ends
  // too — only the countdown's own end means the time is up.
  const expire = (event) => {
    if (event.target === countdown) dismissToast(toast)
  }

  // Following a link renders the page behind: the toast has done its job.
  const click = (event) => {
    if (event.target.closest('[data-toast-close], a[href]')) dismissToast(toast, { fast: true })
  }

  toast.addEventListener('animationend', expire)
  toast.addEventListener('click', click)

  return () => {
    toast.removeEventListener('animationend', expire)
    toast.removeEventListener('click', click)
  }
})
